import * as React from "react";
import { useState } from "react";
import Form from "../commons/components/form/Form";
import { HouseholdInfo, HouseholdMember } from "./HouseholdInfo";
import HouseholdMemberEditablePanel from "./HouseholdMemberEditablePanel";
import { v7 as uuidv7 } from "uuid";
import sfetch from "../commons/utils/super-fetch";
import FormTitle from "../commons/components/form/FormTitle";
import "./HouseholdInfoForm.scss";
import TextAction from "../commons/components/action/TextAction";

class ListItem {
  id: string;
  member: HouseholdMember;

  constructor(id: string, member: HouseholdMember) {
    this.id = id;
    this.member = member;
  }
}

export default function HouseholdInfoForm({
  householdInfo,
  updateUrl,
  title,
  submitLabel,
  afterSubmit,
  skippable,
}: {
  householdInfo?: HouseholdInfo;
  updateUrl: string;
  title?: string;
  submitLabel?: string;
  afterSubmit?: () => any;
  skippable: boolean;
}) {
  const [errorMessage, setErrorMessage] = useState(null);
  const persistedMembers = householdInfo?.members
    ? householdInfo?.members.map((member) => new ListItem(uuidv7(), member))
    : [];
  const [members, setMembers] = useState<ListItem[]>(persistedMembers);

  const submitHouseholdForm = async () => {
    const payload = { members: members.map((item) => item.member) };
    try {
      await sfetch(updateUrl, {
        method: "PUT",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (afterSubmit) {
        afterSubmit();
      }
    } catch (error) {
      setErrorMessage(i18n["Global.TechnicalError"]);
      throw error;
    }
  };

  const skipHouseholdForm = async () => {
    if (afterSubmit) {
      afterSubmit();
    }
  };

  const addMember = () => {
    const newMembers = [...members];
    newMembers.push(
      new ListItem(uuidv7(), {
        firstName: "",
        lastName: "",
        birthdate: "",
        relationship: null,
      }),
    );
    setMembers(newMembers);
  };

  const removeMember = (index: number) => {
    const newMembers = [...members];
    newMembers.splice(index, 1);
    setMembers(newMembers);
  };

  const canAddMember = () => {
    return Object.keys(members).length < 5;
  };

  return (
    <>
      {title && <FormTitle title={title} />}
      {errorMessage && <div className={"form-general-error message danger"}>{errorMessage}</div>}
      <p className={"text-align-center"}>
        <div>{i18n["Form.Household.Intro1"]}</div>
        <div>{i18n["Form.Household.Intro2"]}</div>
      </p>
      <Form
        submit={submitHouseholdForm}
        submitLabel={submitLabel ? submitLabel : i18n["Global.Save"]}
        secondaryAction={skippable ? skipHouseholdForm : null}
        secondaryActionLabel={i18n["Global.Skip"]}
        className={"household-info-form"}
      >
        {members.map((item, index) => (
          <>
            <HouseholdMemberEditablePanel
              id={item.id}
              key={item.id}
              initialValue={item.member}
              onChange={(member) => {
                members[index].member = member;
                setMembers([...members]);
              }}
              onRemove={() => removeMember(index)}
            />
            <hr className={"hr-secondary"} />
          </>
        ))}
        {canAddMember() && (
          <TextAction
            label={i18n["Form.Household.AddAction.Title"]}
            icon={<i className="ic_plus" />}
            additionalClass={skippable ? "text-align-center" : ""}
            onClick={() => addMember()}
          />
        )}
      </Form>
    </>
  );
}
